import React from "react";

import * as Styles from "../leasing-modal-hub.styled";

export const LeasingNoAdminFeesModal = () => {
  return (
    <Styles.LeasingProductModalHeaderAndParagraphContainer>
      <Styles.LeasingProductModalHeader>
        No admin fees
      </Styles.LeasingProductModalHeader>
      <Styles.LeasingProductModalParagraph>
        Unlike many others, we won&apos;t charge you anything to arrange your
        lease.
      </Styles.LeasingProductModalParagraph>
      <Styles.LeasingProductModalParagraph>
        You simply pay your initial payment and fixed monthly payments, no admin
        fees.
      </Styles.LeasingProductModalParagraph>
    </Styles.LeasingProductModalHeaderAndParagraphContainer>
  );
};
